import React from 'react';
import { Translate } from 'react-redux-i18n';
import { Grid, GridColumn, GridRow } from 'semantic-ui-react';
import { accessKeyCreateVertical } from '../../../constants/accessKey';
import { VerticalMenu } from '../../../components/common/VerticalMenu';
import AccessKeyInput from '../../accessKeys/input/AccessKeyInput';

/**
 * Create Access Key content - designed to be embedded in SystemSettings container.
 * Note: This page has its own internal vertical menu for the create form sections.
 */
const CreateAccessKeyContent = () => {
  return (
    <>
      <h2>
        <Translate value={'accessKeys.page.create.title'} />
      </h2>
      <Grid>
        <GridRow>
          <GridColumn width={5}>
            <VerticalMenu menuItems={accessKeyCreateVertical} />
          </GridColumn>
          <GridColumn width={11}>
            <AccessKeyInput />
          </GridColumn>
        </GridRow>
      </Grid>
    </>
  );
};

export default CreateAccessKeyContent;
